<template>
  <div class="page-container">
    <div v-for="item in list" :key="item.goodsId" class="list-item-wrp">
      <GoodsItem
        v-bind="{
          goodsId: item.goodsId,
          goodsImage: item.goodsPic,
          goodsName: item.goodsName,
          goodsPrice: item.salePrice,
          goodsCount: 1,
          goodsCoverSize: 80
        }"
      />
    </div>
  </div>
</template>
<script setup>
import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { GoodsItem } from './component'
import { getGoodsSimpleList } from '@/api/goods'
const router = useRouter()
const { currentRoute } = router
const { query } = currentRoute.value
const { goodsIds } = query
const list = ref([])
const loading = ref(false)
const getList = async () => {
  loading.value = true
  try {
    const resData = await getGoodsSimpleList({ goodsIds: goodsIds.split(','), page: 1, pageSize: 500 })
    list.value.push(...resData.list)
  } finally {
    loading.value = false
  }
}
onMounted(getList)
</script>
<style lang="less" scoped>
.page-container {
  background-color: var(--van-white);
  padding-top: 16px;
  margin-top: 10px;
  overflow: auto;
  .list-item-wrp {
    padding: 0 16px 16px 16px;
    background-color: var(--van-white);
    + .list-item-wrp {
      margin-top: 5px;
    }
  }
}
</style>
